import { render, staticRenderFns } from "./qs1-15.vue?vue&type=template&id=66d1bb5e&scoped=true&"
import script from "./qs1-15.vue?vue&type=script&lang=js&"
export * from "./qs1-15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d1bb5e",
  null
  
)

export default component.exports